import request from "helpers/api_helper";
import { toast } from "react-toastify";

export const getCategories = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `categories${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch categories");
    return error;
  }
};

export const createCategory = async (data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "categories",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Category created successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to create category");
    return error;
  }
};

export const updateCategory = async (id: number, data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `categories/${id}`,
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Category updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update category");
    return error;
  }
};

export const deleteCategory = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `categories/${id}`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Category deleted successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to delete category");
    return error;
  }
};

export const getCategoryById = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `categories/${id}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch category");
    return error;
  }
};


export const getAllCategories = async () => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `categories?limit=1000`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch categories");
    return error;
  }
};